import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ButtonClickedEvent, withAnalytics } from '@atlassian/mpac-analytics';
import React, { PureComponent } from 'react';
import { makeAnalyticsForInstallableAppIdentifier } from '../../../../analytics/AppId';
import { ANALYTICS_SUBJECT_ID_UPGRADE } from '../../../../analytics/Events';
import { isInstallStatusLoading } from '../../../../records/InstallMode/InstallStatus';
import ConfirmCancelFooter from '../common/ConfirmCancelFooter';
const PRIMARY_CTA_LABEL = 'Upgrade';
export class DialogUpgradeFooterBase extends PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "upgradeApp", installableAppToUpgradeTo => () => {
      this.props.fireAnalyticsEvent(makeAnalyticsForInstallableAppIdentifier(ButtonClickedEvent, ANALYTICS_SUBJECT_ID_UPGRADE, this.props.upgradeInstallMode.installableAppByKeyId, {
        label: PRIMARY_CTA_LABEL
      }).toObject());
      this.props.upgradeApp({
        context: this.props.context,
        hostConfig: this.props.hostConfig,
        installedApp: this.props.upgradeInstallMode.installedApp,
        installableAppByKeyId: this.props.upgradeInstallMode.installableAppByKeyId,
        installableAppToUpgradeTo
      });
    });
    _defineProperty(this, "render", () => this.props.upgradeInstallMode.installableAppToUpgradeTo.flatMap(ia => ia.toOption()).map(ia =>
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-key
    React.createElement(ConfirmCancelFooter, {
      closeInstallDialog: this.props.closeInstallDialog,
      isLoading: isInstallStatusLoading(this.props.upgradeInstallMode.status),
      isPrimaryDisabled: false,
      onPrimaryCTAClick: this.upgradeApp(ia),
      primaryCTALabel: PRIMARY_CTA_LABEL
    })).getOrElseL(() => /*#__PURE__*/React.createElement(ConfirmCancelFooter, {
      closeInstallDialog: this.props.closeInstallDialog,
      isLoading: false,
      isPrimaryDisabled: true,
      primaryCTALabel: PRIMARY_CTA_LABEL
    })));
  }
}
export default withAnalytics(DialogUpgradeFooterBase);